define('payment/handlers/formTemplateHandlers/bankWireWithdrawTemplateHandler',['jquery'], function($) {
    'use strict';

    function changeFormElementFields($selectedCountriesSelect, $bankWireForm) {
        var $selectedCountry = $selectedCountriesSelect.find('option:selected');
        var countryConfig = $selectedCountry.data('config');

        if (countryConfig !== undefined) {
            var countryFormElementClasses = countryConfig.split(',');
            $.each(countryFormElementClasses, function(index, formElementClass) {
                $bankWireForm.find('.' + formElementClass).parent().show();
            });
        }

        $bankWireForm.find('.account-holder').parent().show();
        $bankWireForm.find('.currencies').parent().show();
        $bankWireForm.find('.save-account').parent().show();
    }

    function changeCurrencyDescriptions(selectedCurrency, $bankWireForm) {
        var accPlaceholder = $bankWireForm.find('.account-number').find('input').data('placeholder');
        var ibanPlaceholder = $bankWireForm.find('.iban').find('input').data('placeholder');

        if(selectedCurrency !== '') {
            $bankWireForm.find('.account-number').find('input').attr('placeholder', accPlaceholder + ' (' + selectedCurrency + ')');
            $bankWireForm.find('.iban').find('input').attr('placeholder', ibanPlaceholder + ' (' + selectedCurrency + ')');
        } else {
            $bankWireForm.find('.account-number').find('input').attr('placeholder', accPlaceholder);
            $bankWireForm.find('.iban').find('input').attr('placeholder', ibanPlaceholder);
        }
    }

    function changeCurrency($countrySelect, $bankWireForm) {
        var selectedCurrency = $countrySelect.find('option:selected').data('currency');
        var $selectedCurrencyOption = $bankWireForm.find('.currencies select option:contains("' + selectedCurrency + '")');

        if ($selectedCurrencyOption.length === 0) {
            $bankWireForm.find('.currencies select option:first-child').attr('selected', true);
            changeCurrencyDescriptions('', $bankWireForm);
        } else {
            $selectedCurrencyOption.attr('selected', true);
            changeCurrencyDescriptions(selectedCurrency, $bankWireForm);
        }
    }

    function changeAccountOrIbanInputFields(selectedCode, $bankWireForm) {
        if (selectedCode === 'IBAN')
        {
            $bankWireForm.find('.account-number').parent().hide();
            $bankWireForm.find('.iban').parent().show();
            $bankWireForm.find('.bic-swift').parent().show();
        }
        else if (selectedCode === 'ACCOUNT_NUMBER')
        {
            $bankWireForm.find('.iban').parent().hide();
            $bankWireForm.find('.bic-swift').parent().hide();
            $bankWireForm.find('.account-number').parent().show();
        }
    }

    function resetForm($bankWireForm) {
        $bankWireForm.find('.form-group.row').hide();
        $bankWireForm.find(':input[type=text]').each(function() { $(this).val(''); });
        $bankWireForm.find('.selected-countries').parent().show();
        $bankWireForm.find('.stored').parent().parent().show();
        $bankWireForm.find('.save-account').find('input:checkbox').attr('checked', false);
    }

    function resetAccountSelect($bankWireForm, data) {
        if (data === undefined && $bankWireForm.find('.stored')[0] !== undefined) {
            if ($bankWireForm.find('.stored')[0].selectedIndex !== 0) {
                $bankWireForm.find('.stored option:first-child').attr('selected', true);
            }
        }
    }

    function setupCountrySelectionHandler($bankWireForm) {
        var $selectedCountriesSelect = $bankWireForm.find('.selected-countries select');
        $selectedCountriesSelect.off('change').on('change', {reset: true}, function (e, data) {
            resetForm($bankWireForm);
            resetAccountSelect($bankWireForm, data);
            changeFormElementFields($selectedCountriesSelect, $bankWireForm);
            changeCurrency($selectedCountriesSelect, $bankWireForm);
        });
    }

    function setupOtherCountrySelectionHandler($bankWireForm) {
        var $otherCountriesSelect = $bankWireForm.find('.all-countries select');
        $otherCountriesSelect.off('change').on('change', function () {
            changeCurrency($otherCountriesSelect, $bankWireForm);
        });
    }

    function setupAccountOrIbanSelectionHandler($bankWireForm) {
        var $accountOrIbanSelect = $bankWireForm.find('.iban-or-account-number select');
        $accountOrIbanSelect.off('change').on('change', function () {
            changeAccountOrIbanInputFields(this.value, $bankWireForm);
        });
    }

    function setupCurrencySelectionHandler($bankWireForm) {
        var $currencySelect = $bankWireForm.find('.currencies select');
        $currencySelect.off('change').on('change', function () {
            changeCurrencyDescriptions(this.value, $bankWireForm);
        });
    }

    function setupSavedAccountsSelectionHandler($bankWireForm) {
        var $savedAccountsSelect = $bankWireForm.find('.stored');
        $savedAccountsSelect.off('change').on('change', function () {
            var $selectedCountriesSelect = $bankWireForm.find('.selected-countries select');
            var $otherCountriesSelect = $bankWireForm.find('.all-countries select');
            var $selectedSavedAccount = $savedAccountsSelect.find('option:selected');
            var countryId = $selectedSavedAccount.data('cid');

            var $countrySelect;
            if ($selectedCountriesSelect.find('option[value=' + countryId + ']').length > 0) {
                $countrySelect = $selectedCountriesSelect;
            } else if ($otherCountriesSelect.find('option[value=' + countryId + ']').length > 0) {
                $countrySelect = $otherCountriesSelect;
            } else {
                resetForm($bankWireForm);
                $bankWireForm.find('.selected-countries select option:first-child').attr('selected', true);
                return;
            }

            $countrySelect.find('option[value=' + countryId + ']').attr('selected', true).trigger('change', [{reset: false}]);

            $bankWireForm.find('.save-account').parent().hide();
            $countrySelect.parent().show();
        });
    }

    function setupSaveAccountCheckboxHandler($bankWireForm) {
        var $saveAccountCheckbox = $bankWireForm.find('.save-account').children('input', 'label');
        $saveAccountCheckbox.off('click').on('click', function () {
            $bankWireForm.find('.save-account-input').parent().toggle();
        });
    }

    function setupFormTemplate($bankWireForm) {
        resetForm($bankWireForm);
        setupCountrySelectionHandler($bankWireForm);
        setupOtherCountrySelectionHandler($bankWireForm);
        setupAccountOrIbanSelectionHandler($bankWireForm);
        setupCurrencySelectionHandler($bankWireForm);
        setupSavedAccountsSelectionHandler($bankWireForm);
        setupSaveAccountCheckboxHandler($bankWireForm);
    }

    var bankWireTemplateHandler = {};
    bankWireTemplateHandler.setupFormTemplate = setupFormTemplate;
    return bankWireTemplateHandler;
});

